<template>
  <div class="capsule">
    <b-card class="border-top">
      <div slot="header" class="header">
        <div class="titlebar-wrapper text-right">
          <CapsuleAvatar class="avatar" />

          <div class="titlebar-title">
            <span class="d-inline-block text-block"></span>
          </div>

          <div class="titlebar-occasion">
            <b-button size="sm" variant="unstitched" @click="stitchOutfit()">
              Stitch
            </b-button>
          </div>
        </div>
      </div>

      <CapsuleContent ref="capsuleContent" />
    </b-card>
  </div>
</template>

<script>
import CapsuleAvatar from "@/components/landing/capsuleAnatomy/CapsuleAvatar";
import CapsuleContent from "@/components/landing/capsuleAnatomy/CapsuleContent";
import { mapActions } from "vuex";
import { bus } from "@/main";

export default {
  components: {
    CapsuleAvatar,
    CapsuleContent
  },

  methods: {
    ...mapActions(["addTemporaryOutfit"]),

    stitchOutfit() {
      const payload = {
        topRow: this.getLayerProducts(
          this.$refs.capsuleContent.$refs.capsuleLayerTopRow
        ),
        bottomRow: this.getLayerProducts(
          this.$refs.capsuleContent.$refs.capsuleLayerBottomRow
        )
      };

      this.addTemporaryOutfit(payload);
      bus.$emit("stitchingOutfit");
    },

    getLayerProducts(list) {
      const results = list.map(el => {
        const product = el.getElementsByClassName(
          "swiper-slide swiper-slide-active"
        );
        return {
          layerId: product[0].dataset["layerId"],
          productId: product[0].dataset["productId"],
          filename: product[0].dataset["filename"]
        };
      });

      return results;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

// Header
.titlebar-wrapper {
  text-decoration: none;
  display: flex;
  height: 50px;
  width: 100%;
  font-weight: 300;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;

  .avatar {
    flex: 1;
    width: 20%;
    z-index: 1;
  }

  .titlebar-title {
    flex: 1;
    text-align: center;

    .text-block {
      background-color: #ccc;
      width: 45%;
      height: 10px;
    }
  }

  .titlebar-occasion {
    font-size: 10px;
    flex: 1;

    .text-block {
      background-color: #e1e1e1;
      width: 15%;
      height: 8px;
    }
  }
}

// CARD
.card {
  margin-bottom: 30px;
  border-radius: 0.25em;
  background: white;
  border: 0px;
}

.header {
  display: flex;
  flex-direction: column;
}

.card-header {
  padding: 0 15px 0 15px;
  text-transform: uppercase;
  border-bottom-color: $grey5;

  letter-spacing: 1px;
  color: $primary-blue;
  font-weight: 100;
  font-size: 12px;
  border-radius: 0.25em 0.25em 0 0;
  background-color: #fff !important;
}
.card-body {
  background-color: $grey8;
  border-radius: 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/components/landing/capsuleAnatomy/Capsule.vue